import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { StatiEvento } from 'src/app/model/StatiEvento.enum';
import { DialogService } from 'src/app/services/dialog.service';
import { EntiDataSource } from 'src/app/services/enti.datasource';
import { EntiService } from 'src/app/services/enti.service';
import { EventiService } from 'src/app/services/eventi.service';
import { TemplateService } from 'src/app/services/template.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { ModificaStatiEnteDialogComponent } from '../modifica-stati-ente-dialog/modifica-stati-ente-dialog.component';

@Component({
  selector: 'app-lista-enti-abilitati',
  templateUrl: './lista-enti-abilitati.component.html',
  styleUrls: ['./lista-enti-abilitati.component.css']
})
export class ListaEntiAbilitatiComponent implements OnInit {
  arrowFlag: boolean = false;
  public toolbarClose: Toolbar;
  public toolbarOpen: Toolbar;
  risultatiPerPagina: number = 10;
  dataSource: EntiDataSource;
  acl: string;
  //per nascondere correzione dati
  //PRIMA displayedColumns: string[] = ['selectRaccoltaDati', 'nodeCode', 'descrizione', 'abilitato', 'statoCompilazione', 'dataChiusRaccDati', 'stato', 'dataChiusCorrDati', 'statoCorrDati'];
  displayedColumns: string[] = ['selectRaccoltaDati', 'nodeCode', 'descrizione', 'abilitato', 'dataChiusRaccDati', 'stato'];
  public form: FormGroup;
  isDettaglio: boolean;
  isModifica: boolean;
  allAbilitati: string = "";
  allModStatoComp: string = "";
  allSelectedRaccoltaDati: string = "N";
  controlList: ModelEventiCalamitosi.EnteDto[] = [];
  @Output() primaVoltaDistribuito = new EventEmitter<boolean>();
  @Output() sonoAbilitatiTuttiEntiEvent = new EventEmitter<string>();
  @Output() sonoModStatoCompTuttiEntiEvent = new EventEmitter<string>();
  @Output() emitEnteFilterDto = new EventEmitter<ModelEventiCalamitosi.EnteSearchableDto>();
  @Input() resetAbilitaTuttiEnti: Subject<boolean>;
  templateDistribuito: string = "N";
  @Output() emitEnteConfiguration = new EventEmitter<ModelEventiCalamitosi.EnteDto[]>();
  @Input('ente') aggiornaEnti: Subject<boolean>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  utenteDgpe: boolean = false;
  public searchFilters: ModelEventiCalamitosi.EnteSearchableDto = {
    idTemplate: this.route.snapshot.params.idTemplate ? this.route.snapshot.params.idTemplate : null,
    idEnte: null,
    descrizione: "",
    abilitato: "",
    provincia: "",
    tipologiaEnte: "",
    statoCorrezioneDati: "",
    statoRaccoltaDati: ""
  }
  openToggle: number;
  sonoTuttiApertiRaccDat: number = -1;
  sonoTuttiApertiCorrDat: number = -1;
  isRaccoltaDati: boolean = false;

  constructor(private datePipe: DatePipe, public dialog: MatDialog, private eventoService: EventiService, private templateSvc: TemplateService, private entiService: EntiService, private router: Router, private route: ActivatedRoute, private alertsCenterService: AlertsCenterService, private dialogSvc: DialogService) {
    this.acl = sessionStorage.getItem('acl')


    this.eventoService.getEvento(this.route.snapshot.params.id).subscribe(res => {
      if (this.acl === AclTipo.DPCPL || this.acl === AclTipo.EDEL) {
        if (res.stato == StatiEvento.POST_EMERGENZA || res.stato == StatiEvento.RACCOLTA_DATI_PE) {
          this.displayedColumns = ['nodeCode', 'descrizione', 'abilitato'];
          this.isRaccoltaDati = false;
        } else if(res.stato == StatiEvento.RACCOLTA_DATI || res.stato == StatiEvento.IN_BOZZA) {
          this.isRaccoltaDati = true;
          this.displayedColumns = ['selectRaccoltaDati', 'nodeCode', 'descrizione', 'abilitato', 'dataChiusRaccDati', 'stato'];
        }
      }
      else if (this.acl === AclTipo.DGPE) {
        if (res.stato == StatiEvento.POST_EMERGENZA || res.stato == StatiEvento.RACCOLTA_DATI_PE) {
          //per nascondere correzione dati
          //PRIMA this.displayedColumns = ['selectRaccoltaDati', 'nodeCode', 'descrizione', 'abilitato', 'statoCompilazione', 'stato','dataChiusRaccDati','statoCorrDati','dataChiusCorrDati'];
          this.displayedColumns = ['selectRaccoltaDati', 'nodeCode', 'descrizione', 'abilitato', 'stato','dataChiusRaccDati'];
          this.isRaccoltaDati = true;
        } else {
          this.displayedColumns = ['nodeCode', 'descrizione', 'abilitato'];
          this.isRaccoltaDati = false;
        }
        this.utenteDgpe = true;
      }
    });

    if (this.router.url.includes("dettaglio-template")) {
      this.isDettaglio = true;
      this.isModifica = false;
    } else if (this.router.url.includes("modifica-template")) {
      this.isModifica = true;
      this.isDettaglio = false;
    }
    // this.checkDistribuito();
    this.buildForm();
    this.generateOpenToolBar();
    this.generateCloseToolBar();
  }

  private checkDistribuito() {
    this.templateSvc.getTemplate(this.route.snapshot.params.idTemplate).subscribe(
      res => {
        if (res.flDistribuito === "S") {
          this.templateDistribuito = "S"
        } else if (res.flDistribuito === "N") {
          this.templateDistribuito = "N"
        }
      }
    )
  }

  private showActionButtons() {
    //per nascondere correzione dati
    //this.dataSource.sonoTuttiApertiCorrDat.subscribe(value => {
    //  this.sonoTuttiApertiCorrDat = value;
    //})
    this.dataSource.sonoTuttiApertiRaccDat.subscribe(value => {
      this.sonoTuttiApertiRaccDat = value;
    })
  }

  buildForm() {
    this.form = new FormGroup({
      abilitato: new FormControl(null, null),
      descrizione: new FormControl(null, [Validators.maxLength(2000)]),
      provincia: new FormControl(null, null),
      tipologiaEnte: new FormControl(null, null),
      statoRaccoltaDati: new FormControl(null, null),
      //per nascondere correzione dati
      //statoCorrezioneDati: new FormControl(null, null),
    });
  }

  ngOnInit(): void {
    this.dataSource = new EntiDataSource(this.entiService);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
    /**
      * modificato metodo load enti aggiungendo il fatto che il template sia predefinito e allAbilitati
      */
    // this.dataSource.loadEnti(this.controlList, this.searchFilters, 'idEnte,ASC', 0, this.risultatiPerPagina, this.templateDistribuito);


    this.dataSource.enteSubject.subscribe(enti => {
      if (enti && enti.length > 0) {
        enti.forEach(e => {
          if (e.selezionatoPerRaccoltaDati === undefined) {
            e.selezionatoPerRaccoltaDati = 'N';
          }
        });
        this.updateAllSelectedRaccoltaDatiHeader();
      } else {
        this.allSelectedRaccoltaDati = 'N';
      }
    });

    this.resetAbilitaTuttiEnti.subscribe(res => {
      this.ricercaListaEnti();
    })
  }

  ngAfterViewInit() {
    this.aggiornaEnti.subscribe(res => {
      if (res) {
        this.dataSource.loadEnti(this.controlList, this.searchFilters, 'idEnte,ASC', this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito);
        this.allAbilitati = "";
        this.allModStatoComp = "";
        this.showActionButtons();
        this.checkDistribuito();
      }
    });

    this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);

    this.paginator.page
      .pipe(
        tap(() => {
          this.ricercaListaEnti();
        }))
      .subscribe();

    this.dataSource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
        })
      )
      .subscribe();
  }

  public ricercaListaEnti(resetPage?: boolean): void {
    this.searchFilters = {
      idTemplate: this.route.snapshot.params.idTemplate ? this.route.snapshot.params.idTemplate : null,
      idEnte: null,
      descrizione: this.form.controls.descrizione.value ? this.form.controls.descrizione.value : "",
      abilitato: this.form.controls.abilitato.value ? this.form.controls.abilitato.value : "",
      provincia: this.form.controls.provincia.value ? this.form.controls.provincia.value : "",
      tipologiaEnte: this.form.controls.tipologiaEnte.value ? this.form.controls.tipologiaEnte.value : "",
      statoRaccoltaDati: this.form.controls.statoRaccoltaDati.value ? this.form.controls.statoRaccoltaDati.value : "",
      //per nascondere correzione dati
      //statoCorrezioneDati: this.form.controls.statoCorrezioneDati.value ? this.form.controls.statoCorrezioneDati.value : ""
      statoCorrezioneDati: "",
    }
    this.emitEnteFilterDto.emit(this.searchFilters)
    /**
     * modificato metodo load enti aggiungendo il fatto che il template sia predefinito e allAbilitati
     */
    this.dataSource.loadEnti(this.controlList, this.searchFilters, 'idEnte,ASC', this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito, this.allAbilitati, this.allModStatoComp);
  }


  setSingleRaccoltaDatiSelection(element: ModelEventiCalamitosi.EnteDto, checked: boolean) {
    element.selezionatoPerRaccoltaDati = checked ? 'S' : 'N';
    this.updateAllSelectedRaccoltaDatiHeader();
  }

  setAllRaccoltaDatiSelection(checked: boolean) {
    this.allSelectedRaccoltaDati = checked ? 'S' : 'N';
    this.dataSource.enteSubject.value.forEach(ente => {
      if (ente) {
        ente.selezionatoPerRaccoltaDati = checked ? 'S' : 'N';
      }
    });
  }

  updateAllSelectedRaccoltaDatiHeader() {
    const currentEnti = this.dataSource.enteSubject.value;
    if (!currentEnti || currentEnti.length === 0) {
      this.allSelectedRaccoltaDati = 'N';
      return;
    }

    const numSelected = currentEnti.filter(e => e.selezionatoPerRaccoltaDati === 'S').length;
    const totalEnti = currentEnti.length;

    if (numSelected === totalEnti && totalEnti > 0) {
      this.allSelectedRaccoltaDati = 'S';
    } else {
      this.allSelectedRaccoltaDati = 'N';
    }
  }


  sendConfiguration(element) {
    element.abilitato = element.abilitato === 'S' ? 'N' : 'S';
    element.editatoFE = true;
    this.emitEnteConfiguration.emit(element);
    /**
     * fix
     */
    let present = false;
    this.controlList.forEach((ele, index) => {
      if (ele.nodeCode === element.nodeCode) {
        this.controlList.splice(index, 1);
        present = true;
      }
    });
    if (!present) this.controlList.push(element);
  }

  setAll(completed: boolean) {
    /**
   * fix
   */
    this.controlList = [];
    if (completed === true) {
      this.allAbilitati = "S";
    } else {
      this.allAbilitati = "N"
    }
    if (this.templateDistribuito == 'S') {
      if (this.allAbilitati == 'S') {
        this.sonoAbilitatiTuttiEntiEvent.emit(this.allAbilitati);
      } else {
        this.sonoAbilitatiTuttiEntiEvent.emit("");
      }
    } else {
      this.sonoAbilitatiTuttiEntiEvent.emit(this.allAbilitati);
    }
    /**
  * modificato metodo load enti aggiungendo il fatto che il template sia predefinito e allAbilitati
  */
    this.dataSource.loadEnti(this.controlList, this.searchFilters, 'idEnte,ASC', this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito, this.allAbilitati);
  }

  sendConfigurationModStatoComp(element) {
    element.modificato = element.modificato === 'S' ? 'N' : 'S';
    element.modificatoFE = true;
    this.sonoModStatoCompTuttiEntiEvent.emit(element.modificato);
    /**
     * fix
     */
    let present = false;
    this.controlList.forEach((ele, index) => {
      if (ele.nodeCode === element.nodeCode) {
        this.controlList.splice(index, 1);
        present = true;
      }
    });
    if (!present) this.controlList.push(element);
  }

  setAllModStatoComp(completed: boolean) {
    /**
   * fix
   */
    this.controlList = [];
    if (completed === true) {
      this.allModStatoComp = "S";
    } else {
      this.allModStatoComp = "N"
    }
    this.sonoModStatoCompTuttiEntiEvent.emit(this.allModStatoComp);
    /**
  * modificato metodo load enti aggiungendo il fatto che il template sia predefinito e allModStatoComp
  */
    this.dataSource.loadEnti(this.controlList, this.searchFilters, 'idEnte,ASC', this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito, this.allAbilitati, this.allModStatoComp);
  }

  openModificaStatiEnteDialog(azione: string) {
    //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
    const dialogConfig = new MatDialogConfig();
    let entiDaModificare: ModelEventiCalamitosi.EnteDto[] = [];
    let noEntitiesSelectedMessage: string = "";
    let allSelectionFlag: string = "";

    // L'azione DATACHIRACCDATI (modifica data raccolta dati) è stata spostata su APERACCDATI.
    // APERACCDATI ora è l'unica azione per la Raccolta Dati e gestisce sia stato che data.
    if (azione === 'APERACCDATI') {
      entiDaModificare = this.dataSource.enteSubject.value.filter(element => element.selezionatoPerRaccoltaDati === 'S');
      allSelectionFlag = this.allSelectedRaccoltaDati;
      noEntitiesSelectedMessage = `Selezionare almeno un ente per l'operazione di apertura/riapertura o modifica data.`;
    } else if (azione === 'APECORRDATI' || azione === 'DATACHICORRDATI') {
      if (this.allModStatoComp === 'S') {
        entiDaModificare = this.dataSource.enteSubject.value;
      } else {
        entiDaModificare = this.dataSource.enteSubject.value.filter(element => element.modificato === 'S');
      }
      allSelectionFlag = this.allModStatoComp;
      if (azione === 'APECORRDATI') {
         noEntitiesSelectedMessage = `Selezionare almeno un ente per l'operazione di apertura/riapertura correzione dati.`;
      } else {
         noEntitiesSelectedMessage = `Selezionare almeno un ente per l'operazione di modifica data correzione dati.`;
      }
    } else {
      console.warn("Azione non gestita in openModificaStatiEnteDialog:", azione);
      this.alertsCenterService.showAlert({
        message: `Azione non valida: ${azione}.`,
        type: 'danger',
        autoClosable: false
      });
      return;
    }
    if (entiDaModificare.length === 0 && (allSelectionFlag == null || allSelectionFlag === "" || allSelectionFlag === "N")) {
      this.alertsCenterService.showAlert({
        message: noEntitiesSelectedMessage,
        type: 'danger',
        autoClosable: false
      });
      return;
    }
    this.searchFilters = {
      idTemplate: this.route.snapshot.params.idTemplate ? this.route.snapshot.params.idTemplate : null,
      idEnte: null,
      descrizione: this.form.controls.descrizione.value ? this.form.controls.descrizione.value : "",
      abilitato: this.form.controls.abilitato.value ? this.form.controls.abilitato.value : "",
      provincia: this.form.controls.provincia.value ? this.form.controls.provincia.value : "",
      tipologiaEnte: this.form.controls.tipologiaEnte.value ? this.form.controls.tipologiaEnte.value : "",
      statoRaccoltaDati: this.form.controls.statoRaccoltaDati.value ? this.form.controls.statoRaccoltaDati.value : "",
      //per nascondere correzione dati
      //PRIMA statoCorrezioneDati: this.form.controls.statoCorrezioneDati.value ? this.form.controls.statoCorrezioneDati.value : ""
      statoCorrezioneDati: ""
    }
    dialogConfig.data = {
      entiList: entiDaModificare,
      azione: azione,
      idEvento: this.route.snapshot.params.id,
      idTemplate: this.route.snapshot.params.idTemplate,
      enteFilter: this.searchFilters,
      allModStatoCompilazione: this.allSelectedRaccoltaDati
    }
    const dialogRef = this.dialog.open(ModificaStatiEnteDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      let res = result;
      if (res !== false) {
        this.ricercaListaEnti();

        const notificaDto = res;

        if (notificaDto.azione === 'APERACCDATI') {
          this.inviaNotificaAppIO(notificaDto);
        }

        this.allModStatoComp = "";
        this.allSelectedRaccoltaDati = "N";
        this.dataSource.enteSubject.value.forEach(e => {
          e.selezionatoPerRaccoltaDati = 'N';
          e.modificato = 'N';
        });
        this.sonoAbilitatiTuttiEntiEvent.emit('');
        this.sonoModStatoCompTuttiEntiEvent.emit('');
        if (this.templateDistribuito === 'N') {
          this.primaVoltaDistribuito.next(true);
        }
      }
    });
  }


  /**
  * Gestisce la sottoscrizione alla chiamata di invio notifica AppIO e mostra il messaggio a FE.
  */
  private inviaNotificaAppIO(modStatoCompilazioneEntiDto: ModelEventiCalamitosi.ModStatoCompilazioneEntiDto): void {
    this.entiService.inviaNotificaAppIO(modStatoCompilazioneEntiDto)
      .subscribe(
        (response: ModelEventiCalamitosi.EsitoNotificaDTO) => {
          if (response.esito) {
            //Successo: mostra il messaggio specifico fornito dal backend
            this.alertsCenterService.showAlert({
              //Messaggio: "Notifica inviata su AppIO a tutti gli utenti dei vari uffici coinvolti."
              message: response.messaggioErrore,
              type: 'success',
              autoClosable: false
            });
          }
        },
        //Gestione di errori HTTP (400, 401, 404, 500, di rete)
        err => {
          //Inizializza con il messaggio di fallback generico
          let messageToShow: string = 'Errore di comunicazione: non è stato possibile raggiungere il servizio di notifica.';
          let alertType: 'danger' | 'warning' = 'danger';

          //Tentativo di estrarre il messaggio dal body di errore (atteso GenericErrorDTO per il 500)
          if (err.status === 500 && err.error && err.error.message) {
            //Cattura il messaggio dal GenericErrorDTO restituito dal Controller
            messageToShow = err.error.message;
          } else if (err.status === 400) {
            //Gestione per 400 Bad Request
            if (err.error && err.error.message) {
              messageToShow = `Richiesta non valida: ${err.error.message}`;
            } else {
              messageToShow = 'Richiesta non valida. Verificare i dati inviati.';
            }
          }
          else if (err.status === 401 || err.status === 403) {
            //Gestione specifica degli errori di sicurezza
            messageToShow = 'Autorizzazione negata. Controllare i permessi o effettuare nuovamente il login.';
          }

          this.alertsCenterService.showAlert({
            message: messageToShow,
            type: alertType,
            autoClosable: false
          });
        }
      );
  }



  private generateOpenToolBar() {
    this.toolbarOpen = {
      toolbarCss: 'toolbar-vertical',
      actions: [
        {
          btnTitle: 'Apri compilazione',
          // btnIconClass: 'done',
          btnIconClass: 'assignment',
          btnActionEvent: 'open',
          btnCssClass: 'btn btn-secondary'
        }
      ]
    }
  }

  private generateCloseToolBar() {
    this.toolbarClose = {
      toolbarCss: 'toolbar-vertical',
      actions: [
        {
          btnTitle: 'Chiudi compilazione',
          btnIconClass: 'clear',
          btnActionEvent: 'close',
          btnCssClass: 'btn btn-primary'
        }
      ]
    }
  }

  public handleToolbarEvent(event: ToolbarEvent): void {

    let enteChangeStatus: ModelEventiCalamitosi.AnaDatiRaccoltiDTO = {
      idEnte: event.data.idEnte,
      descrizione: event.data.descrizione,
      idTemplate: this.route.snapshot.params.idTemplate,
      idEvento: this.route.snapshot.params.id,
      jsonAttributi: null,
      opzioni: null,
      stato: null
    }
    let title = ''
    let message = ''
    if (event.event === 'open') {
      enteChangeStatus.stato = 'APE'
      title = 'Apertura compilazione'
      message = "Confermi l'operazione di apertura per l'ente: " + String(event.data.descrizione).bold();
    }
    else if (event.event === 'close') {
      enteChangeStatus.stato = 'CHI'
      title = 'Chiusura compilazione'
      message = "Confermi l'operazione di chiusura compilazione per l'ente: " + String(event.data.descrizione).bold();
    }
    this.dialogSvc.openDialog(title, message).subscribe(
      result => {
        let confirmed = `${result}`;
        if (confirmed == "true") {


          this.entiService.changeStatoEnte(enteChangeStatus).subscribe(res => {

            if (enteChangeStatus.stato === 'APE')
              this.alertsCenterService.showAlert({
                message: `Ente riabilitato alla compilazione con successo`,
                type: 'success',
                autoClosable: false
              });
            else this.alertsCenterService.showAlert({
              message: `Chiusura stato ente avvenuta con successo`,
              type: 'success',
              autoClosable: false
            });


            // modificato metodo load enti aggiungendo il fatto che il template sia predefinito e allAbilitati
            this.dataSource.loadEnti(this.controlList, this.searchFilters, 'idEnte,ASC', this.paginator.pageIndex, this.paginator.pageSize);

          },
            err => {
              this.alertsCenterService.showAlert({
                message: err.error.esitoServizio.descrizioneEsito,
                type: 'danger',
                autoClosable: false
              });
            });
        }
      });
  }

  //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
  @HostListener('document:click', ['$event'])
  documentClick(event) {
    if (event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
  }

  onReset() {
    this.form.reset();
    this.controlList = [];
    this.emitEnteConfiguration.emit(undefined);
    this.allAbilitati = "";
    this.allModStatoComp = "";
    this.allSelectedRaccoltaDati = "N";
    //per nascondere correzione dati
    this.form.controls.statoCorrezioneDati.setValue(""); //aggiunto
    this.ricercaListaEnti();
  }
}
